import request from "@/utils/request";

export function sendSignLanguage(data) {
  return request({
    url: "api/contactus/signlanguage",
    method: "post",
    data
  });
}